import React from 'react'
import Svg from './Svg'
export const SvgCloud = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M20.969 12.933v-.258a6.345 6.345 0 00-6.359-6.36c-2.836 0-5.243 1.805-6.016 4.383-.602-.773-1.547-1.289-2.578-1.289a2.99 2.99 0 00-3.008 3.008v.43C1.289 13.534 0 15.253 0 17.401c0 2.579 2.063 4.727 4.641 4.899h5.07v-3.609H6.703l5.328-7.477 5.586 7.477H14.61V22.3h4.64c2.578-.086 4.727-2.234 4.727-4.813.086-2.062-1.203-3.867-3.008-4.554z" />
  </Svg>
))
SvgCloud.isIcon = true
export default SvgCloud
